<app-header></app-header>
<div class="title-bienvenido">
  Felicitaciones, Bienvenido al metaverso!
</div>
<div class="row tipo-uso">
  <div class="col-md-6 dos-de" (click)="goToPortal('admin')">
    <img src="../../../assets/images/admin.png" alt="" class="img-2d" />
    <p class="title-tipo">Para personalizar su evento haga click aquí</p>
  </div>
  <div class="col-md-6 tres-de" (click)="goToPortal('marketplace')">
    <img src="../../../assets/images/experiencia.jpg" alt="" class="img-3d" />
    <p class="title-tipo">Para visualizar su evento haga click aquí</p>
  </div>
</div>
<app-footer></app-footer>
